module.exports = __webpack_public_path__ + "62668118fc078d656ee1eb168df4ed7d.png";